import React from "react";
import { makeStyles } from "@material-ui/core";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
  toastContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    userSelect: "none",
  },

  toastUpdateButton: {
    marginTop: "8px",
    padding: "6px 10px",
    cursor: "pointer",
    border: "2px solid #3498db",
    borderRadius: "7px",
    transition: "all 0.30s",
    "&:hover": { transform: "translateY(-5px)", }
  },
}));

const ServiceWorkerUpdateToast = ({ closeToast }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const classes = useStyles();


  //  ***************
  //  ** Functions **
  //  ***************
  const handleUpdate = () => {
    navigator.serviceWorker
      .getRegistration()
      .then((registration) => {
        if (registration?.waiting) registration.waiting.postMessage("SKIP_WAITING");
        setTimeout(() => window.location.reload(), 1000);
      });

    closeToast();
  };



  //  ************
  //  ** Return **
  //  ************
  return (
    <div className={classes.toastContainer}>
      <span>
        {i18n.t("serviceWorkerUpdateToast.title")}
      </span>

      <span onClick={handleUpdate} className={classes.toastUpdateButton}>
        {i18n.t("serviceWorkerUpdateToast.button")}
      </span>
    </div>
  );
};

export default ServiceWorkerUpdateToast;
